// extracted by mini-css-extract-plugin
export default {"Container":"chart_Container__twbhs","chat-wrapper":"chart_chat-wrapper__-XIpH","chart":"chart_chart__Q+8ue","details":"chart_details__2bleM"};